import { render, staticRenderFns } from "./dialogConfirmacao.vue?vue&type=template&id=427e59b3&scoped=true&"
import script from "./dialogConfirmacao.vue?vue&type=script&lang=js&"
export * from "./dialogConfirmacao.vue?vue&type=script&lang=js&"
import style0 from "./dialogConfirmacao.vue?vue&type=style&index=0&id=427e59b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e59b3",
  null
  
)

export default component.exports